// TODO: JSDoc

import Vue from 'vue'
import Vuex from 'vuex'
import MediaFeedParsers from '@/mixins/beluga_mediafeed_parsers'
import { vm } from '@/main'
import Helpers from '@/mixins/helpers'

Vue.use(Vuex)

// Constants
const FLASH_TIMEOUT_MS = 50
const CAMPAIGN_TYPE_UNKNOWN = 0
const CAMPAIGN_TYPE_INPROGRESS = 1
const CAMPAIGN_TYPE_UPCOMING = 2
const CAMPAIGN_TYPE_COMPLETED = 3

export const belugaDataModel = new Vuex.Store({
  state: {
    clientId: 'fe-' + Helpers.methods.makeRandomHash(6),
    channels: {},
    campaigns: {},
    platforms: {},
    messages: {},
    previousCampaign: 0,
    selectedCampaign: 0,
    selectedPlatform: 0,
    selectedParameter: null,
    selectedParameterCompare: null,
    selectedFeedItem: null,
    selectedTimestamp: 0,
    selectedWindowStart: 0,
    selectedWindowEnd: 0,
    selectedAsyncDataset: null,
    channelLights: {},
    collapseStates: {}
  },
  mixins: {
    MediaFeedParsers,
    Helpers
  },
  getters: {
    channels: state => state.channels,
    channelLights: state => state.channelLights,
    campaigns: state => state.campaigns,
    platforms: state => state.platforms,
    targets (state, getters) {
      const targets = {}
      if (state.selectedCampaign > 0 && getters.campaignSelected.option_ais) {
        for (const platformId in state.platforms) {
          if (Object.prototype.hasOwnProperty.call(state.platforms, platformId) &&
            state.platforms[platformId].type === 'ais') {
            targets[platformId] = state.platforms[platformId]
          }
        }
      }
      return targets
    },
    messages: state => state.messages,
    campaignPlatforms (state, getters) {
      return (campaignId) => {
        const platforms = []
        let otherPlatforms = []
        if (getters.countPlatforms > 0 && state.selectedCampaign > 0) {
          // Handle main platform
          if (getters.campaignSelected.project_platform in state.platforms) {
            platforms.push(state.platforms[getters.campaignSelected.project_platform])
          }
          // Handle other campaign platforms
          for (const platformId in state.platforms) {
            if (state.campaigns[campaignId].platforms.includes(Number(platformId)) &&
              Number(platformId) !== Number(getters.campaignSelected.project_platform)) {
              otherPlatforms.push(state.platforms[platformId])
            }
          }
          otherPlatforms = otherPlatforms.sort((a, b) => {
            // First: Sort by name, second by name
            return (a.type < b.type) ? 1 : -1
          })
        }
        return platforms.concat(otherPlatforms)
      }
    },
    campaignType (state, getters) {
      return (campaignId) => {
        if (Number(campaignId) > 0) {
          const now = Math.floor((new Date()).getTime() / 1000)
          const campaign = getters.campaign(campaignId)
          if (campaign.timestamp_start > now) {
            return CAMPAIGN_TYPE_UPCOMING
          } else if ((campaign.timestamp_start < now && campaign.timestamp_end > now) ||
            Number(campaign.timestamp_end) === 0) {
            return CAMPAIGN_TYPE_INPROGRESS
          } else {
            return CAMPAIGN_TYPE_COMPLETED
          }
        }
        return CAMPAIGN_TYPE_UNKNOWN
      }
    },
    campaignTimeRange (state, getters) {
      return (campaignId) => {
        // Determine time range
        const campaignType = getters.campaignType(campaignId)
        let start = 0
        let end = 0
        if (campaignType === CAMPAIGN_TYPE_INPROGRESS) {
          start = getters.campaignSelected.timestamp_start
          // end = 0 will return all data until now
        } else if (campaignType === CAMPAIGN_TYPE_COMPLETED) {
          start = getters.campaignSelected.timestamp_start
          end = getters.campaignSelected.timestamp_end
        }
        return { start: Number(start), end: Number(end) }
      }
    },
    sections (state, getters) {
      return (platformId) => {
        try {
          return state.platforms[platformId].sections
        } catch (err) {
          return []
        }
      }
    },
    entities (state, getters) {
      return (platformId) => {
        try {
          return state.platforms[platformId].entities
        } catch (err) {
          return []
        }
      }
    },
    parameters (state, getters) {
      return (platformId, entityId) => {
        try {
          return getters.entities(platformId)[entityId].parameters
        } catch (err) {
          return []
        }
      }
    },
    countPlatforms: state => {
      // TODO: Rename to platformsCount?
      return Object.keys(state.platforms).filter(function (platformId) {
        return state.platforms[platformId].type !== 'ais'
      }).length
    },
    countTargets (state, getters) {
      return Object.keys(getters.targets).length
    },
    campaignSelected: state => state.campaigns[state.selectedCampaign],
    platformSelected: state => state.platforms[state.selectedPlatform],
    asyncDatasetSelected: state => {
      if (state.selectedAsyncDataset !== null) {
        const platformId = state.selectedAsyncDataset.platform_id
        const datasetId = state.selectedAsyncDataset.dataset_id
        if (platformId in state.platforms && datasetId in state.platforms[platformId].async_datasets) {
          return state.platforms[platformId].async_datasets[datasetId]
        }
      }
      return null
    },
    selectedCampaign: state => Number(state.selectedCampaign),
    selectedPlatform: state => Number(state.selectedPlatform),
    selectedAsyncDataset: state => Number(state.selectedAsyncDataset),
    campaignExists (state) {
      return campaignId => {
        return (campaignId in state.campaigns)
      }
    },
    platformExists (state) {
      return platformId => {
        return (platformId in state.platforms)
      }
    },
    entityExists (state, getters) {
      return (platformId, entityId) => {
        return (getters.platformExists(platformId) &&
          (entityId in state.platforms[platformId].entities))
      }
    },
    parameterExists (state, getters) {
      return (platformId, entityId, parameterId) => {
        return (getters.entityExists(platformId, entityId) &&
          (parameterId in state.platforms[platformId].entities[entityId].parameters))
      }
    },
    updateExists (state, getters) {
      return (platformId, entityId, parameterId, timestamp) => {
        return (getters.parameterExists(platformId, entityId, parameterId) &&
          (timestamp in state.platforms[platformId].entities[entityId].parameters[parameterId].updates))
      }
    },
    asyncDatasetExists (state, getters) {
      return (platformId, datasetId) => {
        return (getters.platformExists(platformId) &&
          (datasetId in state.platforms[platformId].async_datasets))
      }
    },
    campaign (state, getters) {
      return (campaignId) => {
        return getters.campaigns[campaignId]
      }
    },
    platform (state, getters) {
      return (platformId) => {
        return getters.platforms[platformId]
      }
    },
    entity (state, getters) {
      return (platformId, entityId) => {
        try {
          return getters.entities(platformId)[entityId]
        } catch (err) {
          return []
        }
      }
    },
    parameter (state, getters) {
      return (platformId, entityId, parameterId) => {
        try {
          return getters.parameters(platformId, entityId)[parameterId]
        } catch (err) {
          return []
        }
      }
    },
    updates (state, getters) {
      return (platformId, entityId, parameterId) => {
        if (typeof getters.parameters(platformId, entityId)[parameterId] === 'undefined') {
          return []
        }
        return getters.parameters(platformId, entityId)[parameterId].updates
      }
    },
    updatesFiltered (state, getters) {
      // Note: Start and end must be in milliseconds
      return (platformId, entityId, parameterId, start, end) => {
        if (typeof getters.parameters(platformId, entityId)[parameterId] === 'undefined') {
          return []
        }
        // Reset end if zero == now
        if (end === 0) {
          end = Number(Date.now())
        }
        return getters.parameters(platformId, entityId)[parameterId].updates.filter(update => {
          return update[0] >= start && update[0] <= end
        })
      }
    },
    currentUpdate (state, getters) {
      return (platformId, entityId, parameterId) => {
        try {
          return getters.parameters(platformId, entityId)[parameterId].current
        } catch (err) {
          return []
        }
      }
    },
    lastUpdate (state, getters) {
      return (platformId, entityId, parameterId) => {
        try {
          return getters.parameters(platformId, entityId)[parameterId].last
        } catch (err) {
          return []
        }
      }
    },
    mediaFeed (state, getters) {
      if (getters.selectedCampaign !== 0) {
        if (getters.campaignSelected.project_feed.trim() !== '' &&
          'project_feed_data' in getters.campaignSelected) {
          return getters.campaignSelected.project_feed_data
        }
      }
      return null
    }
  },
  actions: {
    handle_campaign: function ({ commit, getters }, campaign) {
      if (!getters.campaignExists(campaign.id)) {
        commit('add_campaign', campaign)
        if (typeof vm.$route.params.campaign === 'undefined') {
          if (getters.selectedCampaign === 0) {
            console.log('data model: no campaign selected yet, selecting "' + campaign.name + '"')
            commit('select_campaign', campaign.id)
          }
        } else {
          const urlParam = vm.$route.params.campaign.trim()
          let campaignId = 0
          // Resolve url to campaign id
          // TODO: Move to method
          for (const cid in getters.campaigns) {
            if (Object.prototype.hasOwnProperty.call(getters.campaigns, cid)) {
              if (getters.campaigns[cid].url_id === urlParam) {
                campaignId = Number(cid)
                break
              }
            }
          }
          if (campaignId > 0) {
            if (campaignId !== getters.selectedCampaign) {
              console.log('data model: campaign ' + campaignId + ' selected by url parameter "' + urlParam + '"')
              commit('select_campaign', campaignId)
            }
          } else {
            // console.log('data model: campaign url could not be resolved, selecting "' + campaign.name + '"')
            // commit('select_campaign', campaign.id)
          }
        }
      }
    },
    handle_platform: function ({ commit, getters }, platform) {
      if (!getters.platformExists(platform.id)) {
        commit('add_platform', platform)
      }
      // TODO: Update platform?
    },
    handle_entity: function ({ commit, getters }, entity) {
      if (!getters.entityExists(entity.platform_id, entity.id)) {
        commit('add_entity', entity)
      }
    },
    handle_parameter: function ({ commit, getters }, parameter) {
      if (!getters.parameterExists(parameter.platform_id, parameter.entity_id, parameter.id)) {
        commit('add_parameter', parameter)
      }
    },
    handle_update: function ({ commit, getters }, update) {
      if ('header' in update) {
        // Only process live updates from ROS bridge if...
        // 1. Download of platform structure is complete
        // 2. Download of platform past data is complete
        // 3. Campaign is in progress
        if (update.platform_id in getters.platforms &&
          'last_change' in getters.platform(update.platform_id) &&
          getters.campaignType(getters.selectedCampaign) === CAMPAIGN_TYPE_INPROGRESS) {
          const platform = getters.platform(update.platform_id)
          // If minimum interval of platform/message_type is not met: Skip update
          if (update.message_type in platform.last_updates) {
            if ((Math.floor((new Date()).getTime() / 1000) - platform.last_updates[update.message_type]) > platform.min_interval_live) {
              commit('update_parameters_ros', update)
              platform.last_updates[update.message_type] = Math.floor((new Date()).getTime() / 1000)
            }
          } else {
            // Initialize interval handling
            commit('update_parameters_ros', update)
            platform.last_updates[update.message_type] = Math.floor((new Date()).getTime() / 1000)
          }
        }
      } else {
        // Handle updates from REST API
        commit('update_parameters_rest', update)
      }
    },
    handle_sections: function ({ commit, getters }, sections) {
      for (const sectionId in sections) {
        const section = sections[sectionId]
        if (getters.campaignExists(section.campaign_id) && getters.platformExists(section.platform_id)) {
          commit('add_section', section)
        }
      }
    },
    handle_channel_info: function ({ commit, getters }, channelInfo) {
      if (!(channelInfo.id in getters.channels)) {
        commit('add_channel', channelInfo)
      }
    },
    handle_channel_state: function ({ commit, getters }, channelState) {
      if (channelState.id in getters.channels) {
        commit('update_channel', channelState)
      }
    },
    handle_response: function ({ commit, getters }, response) {
      // Create virtual channel state update to signal busy
      if (!getters.channelLights[Number(response.channel)]) {
        const channelStateBusy = {
          id: Number(response.channel),
          property: 2,
          state: true,
          platform: Number(response.platform)
        }
        const channelStateIdle = {
          id: Number(response.channel),
          property: 2,
          state: false,
          platform: Number(response.platform)
        }
        // Signal busy
        getters.channelLights[Number(response.channel)] = true
        commit('update_channel', channelStateBusy)
        // Wait some time, then signal idle again
        setTimeout(function () {
          commit('update_channel', channelStateIdle)
        }, FLASH_TIMEOUT_MS)
      }
    },
    handle_media_feed: function ({ commit, getters }, data) {
      const campaignId = data.campaignId
      // TODO: Only add feed if not exists!
      if (getters.campaignExists(campaignId)) {
        console.log('data model: parsing media feed of campaign ' + campaignId)
        const feedObj = MediaFeedParsers.methods.parseMediaFeed(data.mediaFeed)
        if (feedObj.success) {
          const commitData = {}
          commitData.campaignId = campaignId
          commitData.feed = feedObj.data
          commit('add_media_feed', commitData)
        }
      }
    },
    handle_keep_alive: function ({ commit, getters }, keepAlive) {
      commit('update_keep_alive', keepAlive)
    }
  },
  mutations: {
    add_campaign (state, campaign) {
      // Remove header from ros message if exists
      delete campaign.header
      // Add campaign to model
      Vue.set(state.campaigns, Number(campaign.id), campaign)
      console.log('data model: campaign "' + campaign.name + '" added')
    },
    add_platform (state, platform) {
      if (typeof platform.name !== 'undefined') {
        // Remove header from ros message if exists
        delete platform.header
        // Create additional fields in platform if not exist
        if (!('entities' in platform)) {
          platform.entities = {}
        }
        if (!('last_updates' in platform)) {
          platform.last_updates = {}
        }
        // FIXME: Async datasets have to be included in common data model (entites, parameters)
        if (!('async_datasets' in platform)) {
          platform.async_datasets = {}
        }
        // Add platform to model
        Vue.set(state.platforms, Number(platform.id), platform)
        console.log('data model: platform "' + platform.name + '" (' + platform.id + ') added')
      }
    },
    add_section (state, section) {
      if (section.platform_id in state.platforms) {
        if (!('sections' in state.platforms[section.platform_id])) {
          state.platforms[section.platform_id].sections = {}
        }
        // TODO: Replace mission id by section id
        Vue.set(state.platforms[section.platform_id].sections, Number(section.mission_id), section)
        console.log('data model: section ' + section.mission_id + ' of platform ' + section.platform_id + ' added')
      }
    },
    add_entity (state, entity) {
      try {
        // Remove header from ros message
        delete entity.header
        // Create parameters in entity if not exists
        if (!('parameters' in entity)) {
          entity.parameters = {}
        }
        // Add entity to platform
        Vue.set(state.platforms[entity.platform_id].entities, Number(entity.id), entity)
        console.log('data model: platform ' + entity.platform_id + ': entity "' + entity.name + '" added')
      } catch {
        // FIXME: Return Promise
      }
    },
    add_parameter (state, parameter) {
      try {
        // Remove header from ros message
        delete parameter.header
        // Create values and current value in parameters
        parameter.last = [0, '']
        parameter.current = [0, '']
        parameter.updates = []
        // Add parameter to entity
        Vue.set(state.platforms[parameter.platform_id].entities[parameter.entity_id].parameters, Number(parameter.id), parameter)
        console.log('data model: platform ' + parameter.platform_id + ': parameter "' + parameter.name + '" added')
      } catch (e) {
        // FIXME: Return Promise
      }
    },
    add_media_feed (state, data) {
      // Add media feed data to campaign
      const campaign = state.campaigns[data.campaignId]
      Vue.set(campaign, 'project_feed_data', data.feed)
      console.log('data model: media feed of campaign "' + campaign.name + '" added')
    },
    add_channel (state, channelInfo) {
      try {
        // Remove header from ros message
        delete channelInfo.header
        // Add additional fields
        channelInfo.active = {}
        channelInfo.busy = {}
        channelInfo.error = false
        // Add to global data model
        Vue.set(state.channels, Number(channelInfo.id), channelInfo)
        // Create channel lights busy flag
        Vue.set(state.channelLights, Number(channelInfo.id), false)
      } catch (e) {
        // FIXME: Return Promise
      }
    },
    add_async_dataset (state, dataset) {
      if (dataset.platform_id in state.platforms) {
        Vue.set(state.platforms[dataset.platform_id].async_datasets, dataset.dataset_id, dataset)
        console.log('data model: asynchronous dataset ' + dataset.dataset_id + ' added to platform "' + dataset.platform_id + '"')
      }
    },
    update_parameters_ros (state, update) {
      const timestamp = update.header.stamp.secs
      const values = JSON.parse(update.values)
      if (update.platform_id in state.platforms) {
        // Set last update timestamp of platform
        Vue.set(state.platforms[update.platform_id], 'last_update', timestamp)
        // Process parameter values
        Object.keys(values).forEach(function (entityId) {
          if (Number(entityId) in state.platforms[update.platform_id].entities) {
            Object.keys(values[entityId]).forEach(function (parameterId) {
              if (Number(parameterId) in state.platforms[update.platform_id].entities[entityId].parameters) {
                const parameter = state.platforms[update.platform_id].entities[entityId].parameters[parameterId]
                // Append parameter update
                let value = values[entityId][parameterId]
                if (parameter.type === 'float' || parameter.type === 'int') {
                  value = Number(value)
                } else if (parameter.type === 'bool') {
                  value = String(value).toLowerCase() !== 'false'
                }
                const newUpdate = [Number(timestamp * 1000), value] // Required for Highcharts
                parameter.updates.push(newUpdate)
                // Resort parameter updates if incoming update is older than current
                // TODO: Removed due to issues, should be completely deleted in the future?
                // if (parameter.last.length > 0 && timestamp * 1000 < parameter.last[0]) {
                //   parameter.updates.sort((a, b) => a[0] > b[0] ? 1 : -1)
                //   console.debug('data model: resorting parameter ' +
                //     update.platform_id + '/' + entityId + '/' + parameterId)
                //   parameter.last = parameter.updates[parameter.updates.length - 2]
                //   parameter.current = parameter.updates[parameter.updates.length - 1]
                // } else {
                // Update current and last value
                parameter.last = parameter.current
                parameter.current = newUpdate
                // }
              } else {
                console.warn('data model: platform ' + update.platform_id +
                  ': parameter ' + entityId + '/' + parameterId + ' does not exist')
              }
            })
          }
        })
        // Set last change timestamp
        if (Object.keys(values).length > 0) {
          if (timestamp > state.platforms[update.platform_id].last_change) {
            Vue.set(state.platforms[update.platform_id], 'last_change', Number(timestamp))
          }
        }
        console.debug('data model: platform ' + update.platform_id + ' received updates via rosbridge')
      }
    },
    update_parameters_rest (state, update) {
      if (update.platform_id in state.platforms) {
        // Set last update timestamp of platform
        Vue.set(state.platforms[update.platform_id], 'last_update', update.timestamp)
        if (Object.keys(update.values).length > 0) {
          // Init last change timestamp
          const lastChange = ('last_change' in state.platforms[update.platform_id]) ? Number(state.platforms[update.platform_id].last_change) : 0
          let newLastChange = lastChange
          // Process parameter updates
          let updatesCount = 0
          if ('entities' in state.platforms[update.platform_id]) {
            Object.keys(update.values).forEach(function (entityId) {
              if ('parameters' in state.platforms[update.platform_id].entities[entityId]) {
                Object.keys(update.values[entityId]).forEach(function (parameterId) {
                  try {
                    if (parameterId in state.platforms[update.platform_id].entities[entityId].parameters) {
                      const parameter = state.platforms[update.platform_id].entities[entityId].parameters[parameterId]
                      // Iterate through updates
                      let tsStart = null
                      let timestamp = null
                      Object.keys(update.values[entityId][parameterId]).forEach(function (tsCompressed) {
                        if (tsStart === null) {
                          // First timestamp is start timestamp
                          tsStart = Number(tsCompressed.substring(1))
                          timestamp = tsStart
                        } else {
                          // Recover original timestamp (remove leading 't' and add start timestamp)
                          // Note: Leading 't' forces key to be treated as string (no automatic key ordering!)
                          timestamp = tsStart + Number(tsCompressed.substring(1))
                        }
                        // Only accept new update if timestamp is newer than platform's last change timestamp
                        // Due to performance reasons avoid checking for existing updates and skip update instead
                        if (Number(timestamp) > lastChange) {
                          // Adapt last change timestamp if necessary
                          if (Number(timestamp) > newLastChange) {
                            newLastChange = Number(timestamp)
                          }
                          // Create update value (use compressed timestamp to address value in transmitted data)
                          let value = update.values[entityId][parameterId][tsCompressed]
                          if (parameter.type === 'float' || parameter.type === 'int') {
                            value = Number(value)
                          } else if (parameter.type === 'bool') {
                            value = String(value).toLowerCase() !== 'false'
                          }
                          // DEBUG output
                          // console.log(update.platform_id + ' / ' + entityId + ' / ' + parameterId + ' / ' + timestamp + ' / ' + value)
                          // Append update
                          parameter.updates.push([Number(timestamp * 1000), value]) // Microseconds required for Highcharts
                          // Increase update counter
                          updatesCount = updatesCount + 1
                        }
                      })
                      // Update current and last parameter update
                      const len = parameter.updates.length
                      if (len > 1) {
                        parameter.last = parameter.updates[len - 2]
                      }
                      parameter.current = parameter.updates[len - 1]
                    }
                  } catch (e) {
                    console.error('data model: error while updating parameters: ' + e)
                  }
                })
              } else {
                console.warn('platform ' + update.platform_id + ': parameters missing!')
              }
            })
          } else {
            console.warn('platform ' + update.platform_id + ': entities missing!')
          }
          // Set last change timestamp
          Vue.set(state.platforms[update.platform_id], 'last_change', Number(newLastChange))
          // Log
          console.debug('data model: platform ' + update.platform_id + ' received ' + updatesCount + ' updates via rest api')
        }
      }
    },
    update_keep_alive (state, keepAlive) {
      if (keepAlive.platform_id in state.platforms) {
        Vue.set(state.platforms[keepAlive.platform_id], 'keep_alive', Date.now())
      } else {
        console.warn('data model: incoming keep alive for platform ' + keepAlive.platform_id + ', but no information on platform available')
      }
    },
    update_channel (state, channelState) {
      try {
        // Remove header from ros message
        delete channelState.header
        const channel = state.channels[Number(channelState.id)]
        channelState.platform = Number(channelState.platform)
        if (Number(channelState.property) === 1) {
          Vue.set(channel.active, channelState.platform, channelState.state)
        } else if (channelState.property === 2) {
          Vue.set(channel.busy, channelState.platform, channelState.state)
        }
      } catch (e) {
        // FIXME: Return Promise
      }
      state.channelLights[channelState.id] = false
    },
    select_campaign (state, campaignId) {
      if (campaignId in state.campaigns) {
        state.previousCampaign = state.selectedCampaign
        state.selectedCampaign = Number(campaignId)
        if (state.campaigns[campaignId].url_id.trim() !== '') {
          const path = '/' + state.campaigns[campaignId].url_id.trim()
          if (path !== vm.$route.path) {
            vm.$router.replace({ path: path, query: vm.$route.query })
          }
        }
        console.log('data model: campaign "' + state.campaigns[campaignId].name + '" selected')
      }
    },
    select_platform (state, platformId, force = false) {
      // All platform IDs are accepted even if they do not exist in the list of platforms yet.
      // As all platforms of each campaign had been checked already for existence on the server,
      // this approach is quite safe and allows asynchronous download and later selection of platforms
      if (Number(platformId) >= 0 && (Number(platformId) !== state.selectedPlatform || force)) {
        state.selectedParameter = null
        state.selectedPlatform = Number(platformId)
        if (Number(platformId) > 0) {
          console.log('data model: platform ' + platformId + ' selected')
        } else {
          console.log('data model: deselecting all platforms')
        }
      }
    },
    select_parameter (state, parameter) {
      state.selectedParameter = parameter
      // If selected parameter is equal compare parameter: Reset
      if (state.selectedParameterCompare !== null) {
        if (state.selectedParameterCompare[0] === parameter[0] &&
          state.selectedParameterCompare[1] === parameter[1] &&
          state.selectedParameterCompare[2] === parameter[2]) {
          state.selectedParameterCompare = null
        }
      }
    },
    select_parameter_compare (state, parameter) {
      state.selectedParameterCompare = parameter
    },
    select_feed_item (state, feedItem) {
      state.selectedFeedItem = feedItem
    },
    select_timestamp (state, { timestamp, data }) {
      state.selectedTimestamp = [timestamp, data]
    },
    select_async_dataset (state, dataset) {
      state.selectedAsyncDataset = dataset
    },
    set_collapse (state, request) {
      Vue.set(state.collapseStates, request.component, request.value)
    },
    toggle_collapse (state, componentId) {
      // Toggle collapse state
      if (!(componentId in state.collapseStates)) {
        Vue.set(state.collapseStates, componentId, true)
      } else {
        Vue.set(state.collapseStates, componentId, !state.collapseStates[componentId])
      }
    }
  }
})
